export const HUBSPOT_CONNECT = {
  START: "HUBSPOT_CONNECT_START",
  SUCCESS: "HUBSPOT_CONNECT_SUCCESS",
  ERROR: "HUBSPOT_CONNECT_ERROR",
};

const defaultConnectState = {
  connectLoading: false,
  connectData: null,
  connectError: false,
};

export const defaultState = {
  ...defaultConnectState,
};

export const EVENTS = {
  HUBSPOT_CONNECT: "HUBSPOT_CONNECT",
  RESET_HUBSPOT_REDUCER: "RESET_HUBSPOT_REDUCER",
};

const hubspotReducer = (state = defaultState, action = {}) => {
  switch (action.event) {
    case EVENTS.RESET_HUBSPOT_REDUCER:
      return defaultState;

    case EVENTS.HUBSPOT_CONNECT:
      return {
        ...state,
        connectLoading: action.type === HUBSPOT_CONNECT.START,
        connectData:
          action.type === HUBSPOT_CONNECT.SUCCESS ? action.payload : null,
        connectError:
          action.type === HUBSPOT_CONNECT.ERROR ? action.payload : false,
      };

    default:
      return state;
  }
};

export default hubspotReducer;
